import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import {
  GetUser,
  ActiveUser,
  InactiveUser,
} from "../../../store/user-store/user-actions";
import Loading from "../../../components/UI/Loading";
import { getTokenInfo } from "../../../utils/Guard";
import "./UserDetail.css";

const UsersDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (!user?.id || user.id === 0) {
      dispatch(GetUser(param.userId, userInfo.Email, true));
    }
  }, [param.userId, dispatch, user?.id, userInfo.Email]);

  const activeHandler = () => {
    dispatch(ActiveUser(param.userId, userInfo.Email));
  };
  const inactiveHandler = () => {
    dispatch(InactiveUser(param.userId, userInfo.Email));
  };
  

  const userData = [
    { label: "Nombre", value: user?.name || "N/A" },
    { label: "Primer apellido", value: user?.surname1 || "N/A" },
    { label: "Segundo apellido", value: user?.surname2 || "N/A" },
    { label: "Tipo de Documento", value: user?.documentType?.name || "N/A" },
    { label: "Identificación", value: user?.identification || "N/A" },
    { label: "Email", value: user?.email || "N/A" },
    { label: "Teléfono", value: user?.cellPhone || "N/A" },
    { label: "País", value: user?.country?.name || "N/A" },
    { label: "Ciudad", value: user?.city || "N/A" },
    { label: "Dirección", value: user?.address || "N/A" },
    { label: "Cargo", value: user?.charge?.name || "N/A" },
    { label: "Departamento", value: user?.department?.name || "N/A" },
    { label: "Organización", value: user?.organization?.name || "N/A" },
  ];

  let activeSuspend;
  if (userInfo.Roles !== undefined && userInfo.Roles.includes("user.active")) {
    activeSuspend = (
      <div className="field col-12 md:col-3 mt-3">
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", width: "180px" }}
          label="Activar"
          className="p-button-success"
          onClick={activeHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-check"
          }
          disabled={notification && notification.status === "pending"}
        />
      </div>
    );
  }
  if (
    user?.status &&
    userInfo.Roles !== undefined &&
    userInfo.Roles.includes("user.inactive")
  ) {
    activeSuspend = (
      <div className="field col-12 md:col-3 mt-3">
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", width: "180px" }}
          label="Suspender"
          className="p-button-warning"
          onClick={inactiveHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-times"
          }
          disabled={notification && notification.status === "pending"}
        />
      </div>
    );
  }

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "100vh" }}
      >
        {!user?.id || user.id <= 0 ? (
          <Loading />
        ) : (
          <Card
            style={{
              backgroundColor: "#F9FAFB",
              marginLeft: "0%",
              boxShadow: "none",
              width: "100%",
              height: "auto",
            }}
          >
            <div
              className="user-info text-center"
              style={{
                borderBottom: "solid #fff",
                fontWeight: "bold",
                paddingBottom: "1.3%",
              }}
            >
              <h2 id="header" className="mb-2" style={{ color: "" }}>
                {user?.name?.toUpperCase() || "N/A"}
              </h2>
              <span
                className="badge bg-label-secondary"
                style={{
                  fontSize: "large",
                  color: "#D34330",
                  fontWeight: "bold",
                }}
              >
                Persona
              </span>
            </div>
            <div className="formgrid grid">
              <div className="field col-12 md:col-12 mt-3">
                <DataTable
                  value={userData}
                  style={{ width: "100%", padding: "1%" }}
                >
                  <Column
                    field="label"
                    style={{
                      width: "25%",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                    bodyStyle={{ textAlign: "left" }}
                  />
                  <Column
                    field="value"
                    style={{ width: "75%", textAlign: "left" }}
                    bodyStyle={{ textAlign: "left" }}
                  />
                </DataTable>
              </div>

              <div className="field col-12 md:col-3 mt-3">
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", width: "180px" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/users");
                  }}
                />
              </div>
              {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("user.edit") && (
                  <div className="field col-12 md:col-3 mt-3">
                    <Button
                      rounded
                      text
                      raised
                      style={{ backgroundColor: "#fff", width: "180px" }}
                      label="Editar"
                      icon="pi pi-file-edit"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/users/edit/${user.id}`);
                      }}
                    />
                  </div>
                )}
              {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("user.manageRoles") && (
                  <div className="field col-12 md:col-3 mt-3">
                    <Button
                      rounded
                      text
                      raised
                      style={{ backgroundColor: "#fff", width: "180px" }}
                      label="Asignar roles"
                      icon="pi pi-lock"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/users/roles/${user.id}`);
                      }}
                    />
                  </div>
                )}
              {activeSuspend}
            </div>
          </Card>
        )}
      </div>
    </>
  );
};

export default UsersDetail;
